import { ActionReducerMap, ActionReducer, MetaReducer } from '@ngrx/store';
// import { storeFreeze } from 'ngrx-store-freeze';
import { storeLogger } from 'ngrx-store-logger';
// import { storageSync } from 'ngrx-store-ionic-storage';
// import { Action } from '@ngrx/store';

import { ObstaclesState, obstaclesReducer } from './obstacles.reducer';
import { ClassificationState, classificationReducer } from './classification.reducer';
import { LeaderboardState, leaderboardReducer } from './leaderboard.reducer';
import { BarriersState, barriersReducer } from './possible-barriers.reducer';
import { FilterState, FilterReducer } from './filter.reducer';

export interface State {
    obstacles: ObstaclesState;
    classification: ClassificationState;
    leaderboard: LeaderboardState;
    barriers: BarriersState;
    filter: FilterState;
};

export const reducers: ActionReducerMap<State> = {
    obstacles: obstaclesReducer,
    classification: classificationReducer,
    leaderboard: leaderboardReducer,
    barriers: barriersReducer,
    filter: FilterReducer
};


function logger(reducer: ActionReducer<State>): any {
    return storeLogger()(reducer);
}

const DEV_REDUCERS: MetaReducer<any, any>[] = [logger];

export const metaReducers: MetaReducer<any, any>[] = [
    ...DEV_REDUCERS
];

export default reducers;



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/core/store/reducers/index.ts